// @flow

export const CERTIFICATION_PAST_DUE_DEFINITIONS = {
  ON_RECERT_DUE_DATE: 'ON_RECERT_DUE_DATE',
  DAY_AFTER_RECERT_DUE_DATE: 'DAY_AFTER_RECERT_DUE_DATE',
  FIRST_OF_MONTH_DUE: 'FIRST_OF_MONTH_DUE',
  THIRTY_DAYS_PRIOR: 'THIRTY_DAYS_PRIOR',
};

export const CERTIFICATION_PAST_DUE_DEFINITION_OPTIONS = [
  {
    value: CERTIFICATION_PAST_DUE_DEFINITIONS.ON_RECERT_DUE_DATE,
    label: 'onRecertDueDate',
  },
  {
    value: CERTIFICATION_PAST_DUE_DEFINITIONS.DAY_AFTER_RECERT_DUE_DATE,
    label: 'dayAfterRecertDueDate',
  },
  {
    value: CERTIFICATION_PAST_DUE_DEFINITIONS.FIRST_OF_MONTH_DUE,
    label: 'firstOfMonthDue',
  },
  {
    value: CERTIFICATION_PAST_DUE_DEFINITIONS.THIRTY_DAYS_PRIOR,
    label: 'thirtyDaysPrior',
  },
];
